export const TRACK_SHIPMENT_PENDING = 'TRACK_SHIPMENT_PENDING';
export const TRACK_SHIPMENT_FULFILLED = 'TRACK_SHIPMENT_FULFILLED';
export const TRACK_SHIPMENT_FAILED = 'TRACK_SHIPMENT_FAILED';
